import React, { useState } from 'react';

interface ChangePasswordFormProps {
  onChangePassword: (oldPassword: string, newPassword: string) => Promise<any>;
  onClose: () => void;
}

const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({ onChangePassword, onClose }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }
    setLoading(true);
    const res = await onChangePassword(oldPassword, newPassword);
    setLoading(false);
    if (res && res.message) {
      setSuccess('Password changed successfully');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } else if (res && res.error) {
      setError(res.error);
    } else {
      setError('Unknown error');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 w-80">
      <h2 className="text-xl font-bold text-slate-800 mb-2">Change Password</h2>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Old Password</label>
        <input type="password" className="w-full border border-slate-300 rounded-md px-3 py-2" value={oldPassword} onChange={e => setOldPassword(e.target.value)} required />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">New Password</label>
        <input type="password" className="w-full border border-slate-300 rounded-md px-3 py-2" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Confirm New Password</label>
        <input type="password" className="w-full border border-slate-300 rounded-md px-3 py-2" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
      </div>
      {error && <div className="text-red-600 text-sm">{error}</div>}
      {success && <div className="text-green-600 text-sm">{success}</div>}
      <div className="flex gap-2 justify-end">
        <button type="button" onClick={onClose} className="px-4 py-2 bg-slate-200 rounded-md font-semibold">Cancel</button>
        <button type="submit" className="px-4 py-2 bg-primary-500 text-white rounded-md font-semibold" disabled={loading}>{loading ? 'Saving...' : 'Change Password'}</button>
      </div>
    </form>
  );
};

export default ChangePasswordForm; 